// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-copy-to-clipboard__ezp7l75G{display:flex;flex-direction:row}.copy-input__f4g8Ntv4{margin-right:5px}.copy-button__nNPEAx20{align-self:flex-end;display:flex;position:relative}.full-width__vAXacYdl{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mpCopyToClipboard": "mp-copy-to-clipboard__ezp7l75G",
	"copyInput": "copy-input__f4g8Ntv4",
	"copyButton": "copy-button__nNPEAx20",
	"fullWidth": "full-width__vAXacYdl"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
